import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { saveData, getData } from "../utils/localStorageManager";
import axios from "axios";
import config from "../configuration/config";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper";

SwiperCore.use([Pagination, Autoplay]);

export function TestimonialSection({ title, subtitle }) {
    const { t: trans, i18n } = useTranslation("heading");
    const lang = i18n.language || 'ar';
    const [testimoinals, setTestimoinals] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        async function fetchData() {
            let testimonialsLocal;
            try {
                const data = JSON.parse(getData("testimonials-" + lang, true));
                if (data && data.length > 0) {
                    setTestimoinals(data);
                    testimonialsLocal = data;
                }
            } catch (error) {
                console.log("Local storage error:", error);
            }

            try {
                const response = await axios.request({
                    baseURL: config.controllURL,
                    url: lang + "/api/sections/testimonials",
                    method: "get",
                });

                if (JSON.stringify(testimonialsLocal) !== JSON.stringify(response.data)) {
                    saveData("testimonials-" + lang, response.data, true);
                    setTestimoinals(response.data);
                }
            } catch (error) {
                console.log("API error:", error);
            }
        }
        fetchData();
    }, [lang]);

    if (!testimoinals?.length) return null;

    const renderTestimonial = (testimonial, index) => {
        const name = testimonial?.name || "";
        const initial = name.trim().charAt(0) || "?";
        return (
            <div className="test" key={index}>
                <div className="test-stars">
                    {[...Array(5)].map((_, i) => (
                        <svg key={i} viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>
                    ))}
                </div>
                <p className="test-quote">{testimonial?.content}</p>
                <div className="test-author">
                    <div className="test-av" style={{ background: `hsl(${index * 90}, 70%, 45%)` }}>
                        {initial}
                    </div>
                    <div className="test-meta">
                        <div className="test-name">{name}</div>
                        <div className="test-role">Verified Customer</div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <section className="sec test-section" style={{ background: "var(--bg2)" }} id='customersSaysElement'>
            <div className="ctn">
                <div className="stag">{title ?? trans("testimonial")}</div>
                <h2 className="sh">
                    {(subtitle ?? trans("testimonial-desc"))
                        .split(' ')
                        .map((word, i, arr) =>
                            i === 1 || i === arr.length - 1 ? (
                                <span key={i} className="gn">{word} </span>
                            ) : (
                                word + ' '
                            )
                        )}
                </h2>
                {isMobile ? (
                    <div className="test-swiper-container" style={{ width: '100%', padding: '10px 0 40px' }}>
                        <Swiper
                            spaceBetween={16}
                            slidesPerView={1.2}
                            pagination={{ clickable: true }}
                            autoplay={{ delay: 3500, disableOnInteraction: false }}
                            breakpoints={{
                                480: { slidesPerView: 1.5 },
                                768: { slidesPerView: 2.2 }
                            }}
                            className="test-swiper"
                        >
                            {testimoinals.map((testimonial, index) => (
                                <SwiperSlide key={index}>
                                    {renderTestimonial(testimonial, index)}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                ) : (
                    <div className="test-grid">
                        {testimoinals?.slice(0, 4).map((testimonial, index) => renderTestimonial(testimonial, index))}
                    </div>
                )}
            </div>
        </section>
    );
}
